import { render, staticRenderFns } from "./AddEditKyc.vue?vue&type=template&id=09304468&scoped=true"
import script from "./AddEditKyc.vue?vue&type=script&lang=js"
export * from "./AddEditKyc.vue?vue&type=script&lang=js"
import style0 from "./AddEditKyc.vue?vue&type=style&index=0&id=09304468&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09304468",
  null
  
)

export default component.exports